import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";

import InputField from "../../../ui/form/InputField";
import Button from "../../../ui/utils/Button";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import SelectField from "../../../ui/form/SelectField";
import useFetch from "../../../../hooks/api/useFetch";

const EditCoupon = ({ data, closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.editState);

    const { data: countryData } = useFetch({
    apiMethod: apiRequest.getCountry,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
  });

  const formik = useFormik({

    initialValues: {
      name: data?.name,
      code: data?.code,
      countryId: data?.countryId?._id,
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      code: Yup.string().required("Code is required"),
      countryId: Yup.string().required("Country is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values, id: data?._id } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Update State</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}

        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">

          <div className="col-span-full">
            <SelectField
              name="countryId"
              label="Country"
              placeholder="Select Country"
              value={formik.values.countryId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              serverError={serverErrors?.countryId}
              error={formik.touched.countryId && formik.errors.countryId}
              options={countryData?.countries?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
            />
          </div>
          <InputField
            name="name"
            label="State Name"
            placeholder="Enter State name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            serverError={serverErrors?.name}
          />
          <InputField
            name="code"
            label="State code"
            placeholder="Enter State Code"
            value={formik.values.code}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.code && formik.errors.code}
            serverError={serverErrors?.code}
          />


        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Updating..."
            isLoading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditCoupon;
